/* What the upload endpoint will actually accept. */

/* Images the server accepts. `.webp` is included — browsers and screenshot
   tools produce it by default now. */
export const ACCEPT_IMAGES = ".jpg,.jpeg,.png,.webp,.heic,.heif";

/* Images plus the document formats, for the general-purpose file inputs. */
export const ACCEPT_DOCUMENTS = `${ACCEPT_IMAGES},.pdf,.csv,.xlsx`;
